export default __webpack_public_path__ + "static/media/Cookies_Policy.e677110b.pdf";